import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import PostCard from "@/components/PostCard";
import { Avatar, Empty, PageHeader, Spinner } from "@/components/common";
import { SearchBox } from "@/components/Layout";
import { FactCard } from "@/pages/Facts";

const Block = ({ title, env, children, testid }) => (
  <section className="space-y-3" data-testid={testid}>
    <p className="env-tag" style={{ color: `hsl(var(${env}))` }}>{title}</p>
    {children}
  </section>
);

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [r, setR] = useState(null);
  useEffect(() => { if (q) { setR(null); api.get(`/search?q=${encodeURIComponent(q)}`).then((x) => setR(x.data)); } }, [q]);
  const total = r ? r.people.length + r.posts.length + r.facts.length : 0;

  return (
    <div className="space-y-8" data-testid="search-page">
      <SearchBox className="sm:hidden" />
      <PageHeader title={q ? `Results for “${q}”` : "Search Middle"} subtitle="People, their Fact posts, and Facts from approved sources." />
      {!q ? null : r === null ? <Spinner /> : total === 0 ? <Empty title="No results" text="Try a different word." /> : (
        <>
          {r.people.length > 0 && (
            <Block title="People" env="--social" testid="search-people">
              <div className="flex flex-wrap gap-3">{r.people.map((u) => <Link key={u.user_id} to={`/u/${u.user_id}`} className="surface flex items-center gap-2 px-3 py-2 hover:border-slate-300"><Avatar user={u} size={30} /><span className="text-sm font-medium">{u.name}</span></Link>)}</div>
            </Block>
          )}
          {r.posts.length > 0 && <Block title="Member Facts" env="--social" testid="search-posts"><div className="max-w-2xl space-y-4">{r.posts.map((p) => <PostCard key={p.id} post={p} />)}</div></Block>}
          {r.facts.length > 0 && <Block title="Facts" env="--facts" testid="search-facts"><div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{r.facts.map((f) => <FactCard key={f.id} f={f} />)}</div></Block>}
        </>
      )}
    </div>
  );
}
